import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createCategory } from "../../../../services/category";
import { useState } from "react";

interface AdminCategoryNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCategoryNew(props: AdminCategoryNewProps) {
    const handleSave = (event: any) => {
        event.preventDefault();

        if (event.target.age_start.value < 1) {
            alert(t("start_age_warning"));
            return false;
        }

        const body = {
            name: event.target.name.value,
            age_start: event.target.age_start.value,
            age_end: event.target.age_end.value
        }
        createCategory(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-category-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_category") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="age_start">
                            <Form.Label aria-required="true">{ t("age_start") }</Form.Label>
                            <Form.Control type="number" name="age_start" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="age_end">
                            <Form.Label aria-required="true">{ t("age_end") }</Form.Label>
                            <Form.Control type="number" name="age_end" required />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}